export default __webpack_public_path__ + "static/media/03.c64cb1e7.jpg";